import { ProductFeature } from './types/product-feature'

/**
 * Global product features singleton
 * Simple, non-reactive storage for product features that can be accessed in report formatters unlike the context
 */
class ProductFeatures {
  private features: string = ''

  setFeatures(features: string): void {
    this.features = features
  }

  getFeatures(): string {
    return this.features
  }

  hasFeature(feature: ProductFeature): boolean {
    return this.features.includes(feature)
  }
}

export const productFeaturesObject = new ProductFeatures()
